import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'campus-froala-viewer',
  templateUrl: './froala-viewer.component.html',
  styleUrls: ['./froala-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FroalaViewerComponent {
  @Input() content: string | SafeHtml;
}
